module.exports = __webpack_public_path__ + "img/stapel-text-01.75b2c6b2.svg";